import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import AuthStorage from '~/Utils/AuthStorage';
import FiltroCorretor from './FiltroCorretor';
import TabelaSaldos from './TabelaSaldos';
import PainelConferencia from './PainelConferencia';

const ConsultarSaldos = () => {
  const [opcoes, setOpcoes] = useState(null);
  const [isLoadingOpcoes, setIsLoadingOpcoes] = useState(true);
  const [saldos, setSaldos] = useState([]);
  const [isLoadingSaldos, setIsLoadingSaldos] = useState(false);
  const [linhaSelecionada, setLinhaSelecionada] = useState(null);
  const [codigoCorretorAtual, setCodigoCorretorAtual] = useState(null);

  useEffect(() => {
    const carregar = async () => {
      try {
        const resp = await api.obterOpcoesSaldos();
        setOpcoes(resp);
        if (resp.is_corretor && !resp.is_gerencial) {
          await carregarSaldos(AuthStorage.getUser().usuario);
        }
      } catch {
        toast.error('Erro ao carregar opcoes.');
      } finally {
        setIsLoadingOpcoes(false);
      }
    };
    carregar();
  }, []);

  const carregarSaldos = async (codigoUsuario) => {
    setLinhaSelecionada(null);
    setIsLoadingSaldos(true);
    setSaldos([]);
    setCodigoCorretorAtual(codigoUsuario);
    try {
      const resp = await api.consultarSaldos(codigoUsuario);
      setSaldos(resp || []);
    } catch {
      toast.error('Erro ao carregar saldos.');
    } finally {
      setIsLoadingSaldos(false);
    }
  };

  const handleLancar = async (dados) => {
    try {
      await api.lancarConferenciaSaldo({ ...dados, codigo_corretor: codigoCorretorAtual });
      toast.success('Lancamento efetuado com sucesso!');
      setLinhaSelecionada(null);
      await carregarSaldos(codigoCorretorAtual);
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao lancar conferencia.');
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Consulta de Saldo" />

      {isLoadingOpcoes ? (
        <Loading label="Carregando..." />
      ) : opcoes && (
        <>
          {opcoes.is_gerencial && (
            <FiltroCorretor onBuscar={carregarSaldos} />
          )}

          {isLoadingSaldos && <Loading label="Carregando saldos..." />}

          {!isLoadingSaldos && saldos.length > 0 && (
            <>
              <TabelaSaldos
                saldos={saldos}
                podeConferir={opcoes.is_corretor && !opcoes.is_gerencial}
                onConferir={(linha) => setLinhaSelecionada(linha)}
                linhaSelecionada={linhaSelecionada}
              />
              {linhaSelecionada && (
                <PainelConferencia
                  linha={linhaSelecionada}
                  onLancar={handleLancar}
                  onCancelar={() => setLinhaSelecionada(null)}
                />
              )}
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default ConsultarSaldos;
